import { requestPost } from '@/common/request';

interface reqParams {
  ids: number[]; //消息ID列表
}

type ResultData = {
  data: boolean;
};

/**
 * 消息中心-消息批量已读
 * 接口文档：https://cf.jd.com/pages/viewpage.action?pageId=1121439607
 */
export default function genericMessageChangeReadStatus(query: reqParams): Promise<RequestResult<ResultData>> {
  return requestPost('/generic/platMktMsgBk/message/changeReadStatus', query);
}
